import { FunctionComponent } from 'react';
import ReactMarkdown, { Options } from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { MarkdownLink, MarkdownText } from './Markdown.styled';

export const Markdown: FunctionComponent<Options> = (props) => (
  <ReactMarkdown
    remarkPlugins={[remarkGfm]}
    components={{ p: MarkdownText, a: MarkdownLink }}
    {...props}
  />
);
